import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import Web3 from 'web3';
import Navigation from './components/Navigation';
import Home from './components/Home';
import About from './components/About';
import Account from './components/Account';
import CollectionDetail from './components/CollectionDetail';
import NotFound from './components/NotFound';

const App = () => {
  const [web3, setWeb3] = useState(null);
  const [account, setAccount] = useState(null);

  useEffect(() => {
    if (window.ethereum) {
      const newWeb3 = new Web3(window.ethereum);
      setWeb3(newWeb3);
    } else if (window.web3) {
      const newWeb3 = new Web3(window.web3.currentProvider);
      setWeb3(newWeb3);
    }

    const savedAccount = localStorage.getItem('walletAddress');
    if (savedAccount) setAccount(savedAccount);
  }, []);  


  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Navigation web3={web3} setAccount={setAccount} />
      <Routes>
        <Route path="/" element={<Home account={account} />} />
        <Route path="/about" element={<About />} />
        <Route path="/account" element={<Account account={account} />} />
        <Route path="/collection/:slug" element={<CollectionDetail />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>
    </Router>
  );
};

export default App;
